(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcc-keepers-vault"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var CYCLE = 5600;

  // ---- hands engine ----
  var imgEl = document.getElementById('rcc-kv-keeper-img');
  var cv = document.getElementById('rcc-kv-magic');
  if (imgEl && cv) (function(){
    var cx = cv.getContext('2d');
    var HANDS = [{fx:0.335,fy:0.66},{fx:0.685,fy:0.66}];
    var parts = [];
    function fit(){
      var r = imgEl.getBoundingClientRect();
      var p = cv.parentElement.getBoundingClientRect();
      cv.width = Math.round(r.width); cv.height = Math.round(r.height) + 70;
      cv.style.width = cv.width + 'px'; cv.style.height = cv.height + 'px';
      cv.style.left = Math.round(r.left - p.left) + 'px';
      cv.style.top = Math.round(r.top - p.top) + 'px';
    }
    addEventListener('resize', fit);
    (function ensureFit(){
      if (!imgEl.complete || imgEl.naturalWidth === 0 || imgEl.getBoundingClientRect().width < 50) { setTimeout(ensureFit, 120); return; }
      fit();
    })();
    function spawn(kind, burst){
      var h = HANDS[Math.random() < 0.5 ? 0 : 1];
      var x = h.fx * cv.width + (Math.random() - 0.5) * cv.width * 0.07;
      var y = h.fy * cv.height + (Math.random() - 0.5) * 16;
      if (kind === 'ember') parts.push({k:'e', x:x, y:y, vx:(Math.random()-0.5)*0.14, vy:0.22+Math.random()*0.3, r:1.6+Math.random()*2.4, a:0, max:(burst?0.95:0.75)+Math.random()*0.05, life:0, span:3800+Math.random()*2600, sway:Math.random()*6.28});
      else if (kind === 'wisp') parts.push({k:'w', x:x, y:y+8, vx:(Math.random()-0.5)*0.08, vy:0.10+Math.random()*0.12, r:18+Math.random()*30, a:0, max:0.10+Math.random()*0.07, life:0, span:6500+Math.random()*3000, sway:Math.random()*6.28});
      else parts.push({k:'g', x:x, y:y, vx:0, vy:0.05, r:3.4+Math.random()*3.0, a:0, max:1.0, life:0, span:900+Math.random()*500, sway:0});
    }
    var last = performance.now(), acc = 0, lastPhase = 1;
    function tick(now){
      if (cv.width < 320) { requestAnimationFrame(tick); return; }
      var dt = Math.min(50, now - last); last = now;
      var phase = (now % CYCLE) / CYCLE;
      if (phase < lastPhase) { for (var i = 0; i < 14; i++) spawn('ember', true); for (var j = 0; j < 4; j++) { spawn('wisp'); spawn('glint'); } }
      lastPhase = phase;
      acc += dt;
      if (acc > 150) { acc = 0; spawn('ember'); if (Math.random() < 0.6) spawn('wisp'); if (Math.random() < 0.4) spawn('glint'); }
      cx.clearRect(0, 0, cv.width, cv.height);
      parts = parts.filter(function(p){ return (p.life += dt) < p.span && p.y < cv.height + 30; });
      for (var n = 0; n < parts.length; n++) {
        var p = parts[n];
        var t = p.life / p.span;
        p.a = p.max * (t < 0.18 ? t / 0.18 : 1 - (t - 0.18) / 0.82);
        p.x += p.vx * dt * 0.06 + Math.sin(now / 900 + p.sway) * 0.12;
        p.y += p.vy * dt * 0.06;
        drawPart(cx, p, t);
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  // ---- glass card magic: soft embers + glints over the story box ----
  var gcv = document.getElementById('rcc-kv-glass-magic');
  if (gcv) (function(){
    var cx = gcv.getContext('2d');
    var parts = [];
    function fit(){
      var r = gcv.parentElement.getBoundingClientRect();
      gcv.width = Math.round(r.width); gcv.height = Math.round(r.height);
    }
    addEventListener('resize', fit);
    setTimeout(fit, 250);
    function spawn(kind){
      if (kind === 'ember') parts.push({k:'e', x: Math.random()*gcv.width, y: gcv.height + 6, vx:(Math.random()-0.5)*0.06, vy:-(0.08+Math.random()*0.12), r:1.0+Math.random()*1.6, a:0, max:0.4+Math.random()*0.25, life:0, span:7000+Math.random()*4000, sway:Math.random()*6.28});
      else parts.push({k:'g', x: Math.random()*gcv.width, y: Math.random()*gcv.height, vx:0, vy:0, r:2.2+Math.random()*2.0, a:0, max:0.8, life:0, span:900+Math.random()*600, sway:0});
    }
    var last = performance.now(), acc = 0;
    function tick(now){
      if (gcv.width < 100) { requestAnimationFrame(tick); return; }
      var dt = Math.min(50, now - last); last = now;
      acc += dt;
      if (acc > 420) { acc = 0; spawn('ember'); if (Math.random() < 0.3) spawn('glint'); }
      cx.clearRect(0, 0, gcv.width, gcv.height);
      parts = parts.filter(function(p){ return (p.life += dt) < p.span && p.y > -20; });
      for (var n = 0; n < parts.length; n++) {
        var p = parts[n];
        var t = p.life / p.span;
        p.a = p.max * (t < 0.15 ? t / 0.15 : 1 - (t - 0.15) / 0.85);
        p.x += p.vx * dt * 0.06 + Math.sin(now / 1000 + p.sway) * 0.08;
        p.y += p.vy * dt * 0.06;
        drawPart(cx, p, t);
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  // ---- belt ember stream ----
  var bcv = document.getElementById('rcc-kv-belt-magic');
  if (bcv) (function(){
    var cx = bcv.getContext('2d');
    var parts = [];
    function fit(){
      var r = bcv.parentElement.getBoundingClientRect();
      bcv.width = Math.round(r.width); bcv.height = Math.round(r.height);
    }
    addEventListener('resize', fit);
    fit();
    function spawn(kind, burst){
      var y = bcv.height * (0.12 + Math.random() * 0.5);
      if (kind === 'ember') parts.push({k:'e', x: bcv.width + 10, y:y, vx:-(0.55+Math.random()*0.75), vy:0.03+Math.random()*0.05, r:1.4+Math.random()*2.2, a:0, max:(burst?0.9:0.6)+Math.random()*0.1, life:0, span:9000+Math.random()*5000, sway:Math.random()*6.28});
      else if (kind === 'wisp') parts.push({k:'w', x: bcv.width + 30, y:y, vx:-(0.30+Math.random()*0.3), vy:0.01, r:22+Math.random()*34, a:0, max:0.07+Math.random()*0.05, life:0, span:12000+Math.random()*5000, sway:Math.random()*6.28});
      else parts.push({k:'g', x: Math.random()*bcv.width, y:y, vx:-0.1, vy:0, r:3+Math.random()*2.6, a:0, max:0.95, life:0, span:800+Math.random()*500, sway:0});
    }
    var last = performance.now(), acc = 0, lastPhase = 1;
    function tick(now){
      if (bcv.width < 320) { requestAnimationFrame(tick); return; }
      var dt = Math.min(50, now - last); last = now;
      var phase = (now % CYCLE) / CYCLE;
      if (phase < lastPhase) { for (var i = 0; i < 8; i++) spawn('ember', true); spawn('wisp'); spawn('glint'); spawn('glint'); }
      lastPhase = phase;
      acc += dt;
      if (acc > 200) { acc = 0; spawn('ember'); if (Math.random() < 0.35) spawn('wisp'); if (Math.random() < 0.3) spawn('glint'); }
      cx.clearRect(0, 0, bcv.width, bcv.height);
      parts = parts.filter(function(p){ return (p.life += dt) < p.span && p.x > -40; });
      for (var n = 0; n < parts.length; n++) {
        var p = parts[n];
        var t = p.life / p.span;
        p.a = p.max * (t < 0.1 ? t / 0.1 : 1 - (t - 0.1) / 0.9);
        p.x += p.vx * dt * 0.06;
        p.y += p.vy * dt * 0.06 + Math.sin(now / 1100 + p.sway) * 0.10;
        drawPart(cx, p, t);
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  function drawPart(cx, p, t){
    if (p.k === 'e') {
      var g1 = cx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 3);
      g1.addColorStop(0, 'rgba(228,189,104,' + p.a + ')');
      g1.addColorStop(0.5, 'rgba(196,151,59,' + p.a * 0.5 + ')');
      g1.addColorStop(1, 'rgba(196,151,59,0)');
      cx.fillStyle = g1; cx.beginPath(); cx.arc(p.x, p.y, p.r * 3, 0, 6.29); cx.fill();
    } else if (p.k === 'w') {
      var g2 = cx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
      g2.addColorStop(0, 'rgba(200,180,140,' + p.a + ')');
      g2.addColorStop(1, 'rgba(200,180,140,0)');
      cx.fillStyle = g2; cx.beginPath(); cx.arc(p.x, p.y, p.r, 0, 6.29); cx.fill();
    } else {
      cx.strokeStyle = 'rgba(236,228,210,' + p.a + ')'; cx.lineWidth = 1;
      var s = p.r * (1 - t * 0.4);
      cx.beginPath();
      cx.moveTo(p.x - s, p.y); cx.lineTo(p.x + s, p.y);
      cx.moveTo(p.x, p.y - s); cx.lineTo(p.x, p.y + s);
      cx.moveTo(p.x - s*0.5, p.y - s*0.5); cx.lineTo(p.x + s*0.5, p.y + s*0.5);
      cx.moveTo(p.x + s*0.5, p.y - s*0.5); cx.lineTo(p.x - s*0.5, p.y + s*0.5);
      cx.stroke();
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcc-oop-vanish"] && !Shopify.designMode) return;
  try {
    
(function(){
document.querySelectorAll('.rcc-ov').forEach(function(root){
  var poolEl = root.querySelector('[data-ov-pool]');
  var grid = root.querySelector('[data-ov-grid]');
  if (!poolEl || !grid) return;
  var POOL;
  try { POOL = JSON.parse(poolEl.textContent); } catch(e) { return; }
  if (!POOL.length) return;
  // shuffle per pageload — different visitors (and reloads) lead with different pieces
  for (var s = POOL.length - 1; s > 0; s--) { var rr = Math.floor(Math.random() * (s + 1)); var tp = POOL[s]; POOL[s] = POOL[rr]; POOL[rr] = tp; }

  function cardHTML(it){
    return '<div class="ph"><img src="' + it.img + '" alt="" loading="lazy"></div><div class="inf"><p class="t"></p><div class="pr">' + it.p + '</div></div>';
  }
  function build(it){
    var a = document.createElement('a');
    a.className = 'rcc-ov-card'; a.href = it.u;
    a.innerHTML = cardHTML(it);
    a.querySelector('.t').textContent = it.t; // textContent = safe for any title
    return a;
  }
  var visible = Math.min(8, POOL.length);
  for (var i = 0; i < visible; i++) grid.appendChild(build(POOL[i]));
  if (POOL.length <= visible) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var next = visible;
  setInterval(function(){
    if (document.hidden) return;
    var cards = grid.children;
    var slot = Math.floor(Math.random() * cards.length);
    var card = cards[slot];
    // pick the next pool item NOT currently on the grid — the same piece must never
    // replace itself or appear twice (Jefe 2026-07-11: "the same item?!")
    var onGrid = {};
    for (var g = 0; g < cards.length; g++) onGrid[cards[g].getAttribute('href')] = 1;
    var it = null, tries = 0;
    while (tries < POOL.length) {
      var cand = POOL[next % POOL.length]; next++; tries++;
      if (!onGrid[cand.u]) { it = cand; break; }
    }
    if (!it) return; // whole pool is on the grid — nothing new to show this cycle
    card.classList.add('vanish');
    setTimeout(function(){
      card.href = it.u;
      card.innerHTML = cardHTML(it);
      card.querySelector('.t').textContent = it.t;
      card.classList.remove('vanish');
      card.classList.add('appear');
      setTimeout(function(){ card.classList.remove('appear'); }, 1100);
    }, 950);
  }, 3400);
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcc-related"] && !Shopify.designMode) return;
  try {
    
(function(){
  var host = document.querySelector('.rcc-rel');
  var grid = document.getElementById('rcc-rel-grid');
  if (!host || !grid) return;
  var currentId = host.dataset.currentId;
  var artist = host.dataset.artistHandle;
  var genre = host.dataset.genreHandle;
  var format = host.dataset.formatHandle;

  // deterministic per-product randomness: same product page always shows the same shelf,
  // different products show different slices of the genre
  var seed = 0;
  for (var i = 0; i < currentId.length; i++) seed = (seed * 31 + currentId.charCodeAt(i)) >>> 0;
  function rng() { seed = (seed + 0x6D2B79F5) >>> 0; var t = seed; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(rng() * (i + 1)); var x = a[i]; a[i] = a[j]; a[j] = x; } return a; }
  var sorts = ['title-ascending','title-descending','price-ascending','price-descending','created-ascending','created-descending'];
  var sortPick = sorts[Math.floor(rng() * sorts.length)];

  function extract(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var cards = doc.querySelectorAll('[data-rel-card]');
    var out = [];
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].dataset.relId === currentId) continue;
      out.push(cards[i]);
    }
    return out;
  }

  function fill(cards) {
    var seen = {};
    for (var i = 0; i < grid.children.length; i++) seen[grid.children[i].dataset.relId] = 1;
    var have = grid.children.length;
    for (var j = 0; j < cards.length && have < 4; j++) {
      if (seen[cards[j].dataset.relId]) continue;
      grid.appendChild(cards[j]); have++;
    }
    return have;
  }

  function fetchShelf(url) {
    return fetch(url)
      .then(function(r){ return r.ok ? r.json() : {}; })
      .then(function(j){ return extract(j['rcc-related-source'] || ''); })
      .catch(function(){ return []; });
  }

  // FORMAT IS A HARD CONSTRAINT (Jefe 2026-07-12: a "shelf" = one format; a cassette page must
  // never show an 8-track or CD). Every step is nested inside the item's own format collection
  // (/collections/{format}/{tag}), so the relatedness ladder — same artist → same genre → any —
  // only ever refines WITHIN that format. If there's no format collection (toys/dvd), show nothing.
  if (!format) { host.style.display = 'none'; return; }

  var artistStep = artist
    ? fetchShelf('/collections/' + format + '/' + artist + '?sections=rcc-related-source').then(fill)
    : Promise.resolve(0);

  artistStep.then(function(have){
    if (have >= 4 || !genre) return have;
    return fetchShelf('/collections/' + format + '/' + genre + '?sort_by=' + sortPick + '&sections=rcc-related-source')
      .then(function(cards){ return fill(shuffle(cards)); });
  }).then(function(have){
    if (have >= 4) return have;
    return fetchShelf('/collections/' + format + '?sort_by=' + sortPick + '&sections=rcc-related-source')
      .then(function(cards){ return fill(shuffle(cards)); });
  }).then(function(){
    if (!grid.children.length) host.style.display = 'none'; // nothing relevant — show nothing, never junk
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcc-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  var canvas = document.getElementById('rcc-ts-magic');
  var host = canvas && canvas.closest('.rcc-ts');
  if (!canvas || !host) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ctx = canvas.getContext('2d');
  var W, H, dpr = Math.min(window.devicePixelRatio || 1, 2);
  function size(){ W = host.clientWidth; H = host.clientHeight; canvas.width = W*dpr; canvas.height = H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0); }
  size(); window.addEventListener('resize', size);

  var N = Math.min(150, Math.round(W / 12));
  var embers = [];
  for (var i = 0; i < N; i++) embers.push(spawn(true));
  function spawn(anywhere){
    return {
      x: Math.random()*W, y: anywhere ? Math.random()*H : H + 10,
      r: .6 + Math.random()*2.1, vy: -(4 + Math.random()*14)/60, vx: (Math.random()-.5)*10/60,
      tw: Math.random()*Math.PI*2, tws: .5 + Math.random()*2.2, a: .25 + Math.random()*.6
    };
  }
  var flares = [];
  function flare(){
    flares.push({ x: Math.random()*W, y: Math.random()*H*.9, r: 0, max: 26 + Math.random()*46, a: .8 });
    setTimeout(flare, 700 + Math.random()*1800);
  }
  setTimeout(flare, 800);

  var last = performance.now();
  function tick(now){
    var dt = Math.min(50, now - last); last = now;
    ctx.clearRect(0,0,W,H);
    for (var i = 0; i < embers.length; i++){
      var e = embers[i];
      e.x += e.vx*dt*.06; e.y += e.vy*dt*.06; e.tw += e.tws*dt/1000;
      if (e.y < -12 || e.x < -12 || e.x > W+12) embers[i] = e = spawn(false);
      var glow = e.a * (0.55 + 0.45*Math.sin(e.tw));
      ctx.beginPath(); ctx.arc(e.x, e.y, e.r, 0, 6.2832);
      ctx.fillStyle = 'rgba(216,172,78,' + glow.toFixed(3) + ')';
      ctx.shadowColor = 'rgba(196,151,59,.9)'; ctx.shadowBlur = 8;
      ctx.fill(); ctx.shadowBlur = 0;
    }
    for (var j = flares.length-1; j >= 0; j--){
      var f = flares[j];
      f.r += dt*.05*(f.max/26); f.a -= dt*.0011;
      if (f.a <= 0 || f.r >= f.max){ flares.splice(j,1); continue; }
      var g = ctx.createRadialGradient(f.x,f.y,0,f.x,f.y,f.r);
      g.addColorStop(0,'rgba(240,210,140,' + (f.a*.5).toFixed(3) + ')');
      g.addColorStop(.4,'rgba(196,151,59,' + (f.a*.22).toFixed(3) + ')');
      g.addColorStop(1,'rgba(196,151,59,0)');
      ctx.beginPath(); ctx.arc(f.x,f.y,f.r,0,6.2832); ctx.fillStyle = g; ctx.fill();
      ctx.strokeStyle = 'rgba(240,210,140,' + (f.a*.6).toFixed(3) + ')'; ctx.lineWidth = 1;
      ctx.beginPath(); ctx.moveTo(f.x-f.r*1.15,f.y); ctx.lineTo(f.x+f.r*1.15,f.y); ctx.moveTo(f.x,f.y-f.r*1.15); ctx.lineTo(f.x,f.y+f.r*1.15); ctx.stroke();
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();

  } catch(e) { console.error(e); }
})();
})();
